import { UniqueIdentifier } from '@dnd-kit/core';
import { createContext, useContext } from 'react';
import type { Entity } from '@shared/data/entity';
import { API } from '@shared/types/api';
export interface ActiveCard {
  id: string;
  groupId: UniqueIdentifier;
  entity: Entity;
  workflowEntity: API.WorkflowEntity;
  nextEntity?: API.WorkflowEntity;
  prevEntity?: API.WorkflowEntity;
}

export interface DraggableContextValue {
  isDragEnabled: boolean;
  isDragSortEnabled: boolean;
  isDragging: boolean;
  activeCards: ActiveCard[];
  activeGroupId?: UniqueIdentifier;
}

export const DraggableContext = createContext<DraggableContextValue>({
  isDragEnabled: false,
  isDragSortEnabled: false,
  isDragging: false,
  activeCards: [],
});

export function useDraggableContext() {
  return useContext(DraggableContext);
}
